import { createContext, useCallback, useContext, useMemo, useState } from 'react';

const LanguageContext = createContext();

const translations = {
  es: {
    nav: {
      home: 'Inicio',
      admissions: 'Admisiones',
      about: 'Acerca de',
      contact: 'Contáctanos',
      volunteer: 'Voluntariado'
    },
    common: {
      brand: 'CEAM',
      schoolName: 'Centro Educativo Adventista de Monteverde',
      schedule: 'Horario',
      weekHours: 'Lunes a jueves: 8:00 a.m. - 4:00 p.m. Viernes: 8:00 a.m. - 12:45 p.m.',
      weekendHours: 'Sábados y domingos: Cerrado',
      enrollment2026: 'Matrícula 2026',
      enrollmentOpen: 'Abierta y disponible',
      familyInvite: '¡Ven y sé parte de nuestra familia!',
      website: 'Página web',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      address: 'Dirección',
      accounting: 'Contabilidad'
    },
    footer: {
      rights: '© 2026 Centro Educativo Adventista de Monteverde. Todos los derechos reservados.'
    },
    home: {
      eyebrow: 'Educación integral con valores',
      heroTitle: 'Centro Educativo Adventista de Monteverde',
      heroLead: 'Formamos estudiantes con excelencia académica, principios cristianos y compromiso con la comunidad.',
      visit: 'Agenda una visita',
      viewLevels: 'Ver niveles',
      years: 'Años de experiencia',
      students: 'Estudiantes',
      teachers: 'Docentes',
      heroCardTitle: 'Con Jesús a Nuestro Lado un Futuro Ilimitado',
      heroCardText: 'Descubre un ambiente seguro, moderno y acogedor para el crecimiento integral de tus hijos.',
      heroCardList1: 'Preescolar y Primaria',
      heroCardList2: 'Programas de música, ciencia y deportes',
      heroCardList3: 'Atención personalizada y acompañamiento espiritual',
      requestInfo: 'Solicitar información',
      pillarsTitle: 'Nuestros pilares',
      pillar1Title: 'Excelencia académica',
      pillar1Text: 'Programas actualizados y docentes comprometidos con el aprendizaje.',
      pillar2Title: 'Valores cristianos',
      pillar2Text: 'Formación espiritual basada en el amor, servicio y respeto.',
      pillar3Title: 'Comunidad activa',
      pillar3Text: 'Proyectos solidarios y actividades que fortalecen el carácter.',
      servicesTitle: 'Servicios destacados',
      service1Title: 'Laboratorios y tecnología',
      service1Text: 'Espacios equipados para impulsar la creatividad y la investigación.',
      service2Title: 'Arte y cultura',
      service2Text: 'Coros, bandas y talleres artísticos para el desarrollo integral.',
      service3Title: 'Deporte y bienestar',
      service3Text: 'Fomento de hábitos saludables y trabajo en equipo.',
      volunteerTitle: 'Voluntariado',
      volunteerText: 'Conoce y aplica a nuestras oportunidades de voluntariado.',
      volunteerButton: 'Ver oportunidades'
    },
    volunteer: {
      title: 'Voluntariado',
      lead: 'Conoce y aplica a nuestras oportunidades de voluntariado.',
      monteverde: 'Voluntariado en Monteverde',
      monteverdeDesc: 'Colabora con nuestra escuela en Monteverde y sé parte de la transformación educativa.',
      santaElena: 'Voluntariado en Santa Elena',
      santaElenaDesc: 'Únete a nuestro programa de voluntariado en Santa Elena y marca la diferencia.',
      button1: 'Ver oportunidades',
      button2: 'Ver oportunidades'
    },
    admissions: {
      title: 'Niveles educativos',
      subtitle: 'Pago en 11 mensualidades',
      preschool: 'Preescolar',
      preschoolDesc: 'Formación lúdica y desarrollo integral en edades tempranas.',
      primary: 'Primaria',
      primaryDesc: 'Educación académica con énfasis en valores y habilidades.',
      infoTitle: 'Información',
      info1: 'Educación personalizada',
      info2: 'Ambientes seguros y modernos',
      info3: 'Desarrollo de habilidades',
      info4: 'Actividades lúdicas',
      info5: 'Excelencia académica',
      info6: 'Educación integral',
      info7: 'Formación de valores',
      info8: 'Acompañamiento personalizado',
      enrollmentFee: 'Matrícula',
      monthlyFee: 'Mensualidad',
      requestInfo: 'Solicitar información',
      uniformsTitle: 'Uniformes escolares',
      polo: 'Camisa de polo diario',
      pe: 'Camisa de educación física',
      books: 'Libros',
      booksNote: 'Consultar en el centro educativo o al',
      programsTitle: 'Programas especiales',
      program1Title: 'Inglés con voluntarios nativos',
      program1Text: 'Inmersión en el idioma inglés con docentes especializados.',
      program2Title: 'Laboratorio de computación y robótica',
      program2Text: 'Preparación para los retos tecnológicos del mañana.',
      program3Title: 'Aprendizaje B-learning',
      program3Text: 'Experiencias lúdicas y proyectos experimentales innovadores.'
    },
    contact: {
      title: 'Contáctanos',
      lead: '¿Tienes preguntas? Nos encantaría escucharte. Completa el formulario y nos pondremos en contacto.',
      success: '✓ Mensaje enviado correctamente',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      message: 'Mensaje',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'tu@email.com',
      phonePlaceholder: '+506 ____-____',
      messagePlaceholder: 'Cuéntanos tu consulta...',
      send: 'Enviar mensaje',
      infoTitle: 'Información de contacto',
      hours: 'Horario:',
      enrollmentOpen: 'Matrícula 2026 abierta',
      enrollmentInvite: '¡Sé parte de nuestra familia!',
      address: 'Dirección',
      web: 'Web'
    },
    about: {
      title: 'Acerca de nosotros',
      lead: 'Conoce la historia, misión y valores del Centro Educativo Adventista de Monteverde',
      historyTitle: 'Nuestra Historia',
      historyP1: 'El Centro Educativo Adventista de Monteverde (CEAM) nace con la visión de ofrecer una educación integral que combine excelencia académica con formación de valores cristianos. Con más de 25 años de experiencia, hemos impactado la vida de cientos de estudiantes y sus familias.',
      historyP2: 'Desde nuestros inicios, hemos mantenido el compromiso de ser más que una escuela: somos una familia dedicada a la educación integral de nuestros estudiantes bajo principios bíblicos.',
      missionTitle: 'Nuestra Misión',
      missionP1: 'Proporcionar una educación integral de calidad que desarrolle en nuestros estudiantes excelencia académica, valores cristianos sólidos y compromiso con la comunidad. Buscamos formar ciudadanos responsables y éticos que contribuyan positivamente a la sociedad.',
      valuesTitle: 'Nuestros Valores',
      value1: 'Excelencia',
      value1Text: 'Nos esforzamos por la máxima calidad en todo lo que hacemos',
      value2: 'Integridad',
      value2Text: 'Actuamos con honestidad y transparencia en todas nuestras acciones',
      value3: 'Amor',
      value3Text: 'Demostramos amor cristiano en nuestras relaciones',
      value4: 'Responsabilidad',
      value4Text: 'Asumimos compromisos y cumplimos con nuestras obligaciones',
      value5: 'Respeto',
      value5Text: 'Valoramos y respetamos la dignidad de cada persona',
      chooseTitle: '¿Por qué elegir CEAM?',
      feature1Title: 'Educación Integral',
      feature1Text: 'Desarrollamos todas las áreas del ser humano: académica, emocional, física y espiritual',
      feature2Title: 'Excelencia Académica',
      feature2Text: 'Docentes capacitados, metodologías modernas y programas actualizados',
      feature3Title: 'Valores Cristianos',
      feature3Text: 'Formación basada en principios bíblicos que transforman vidas',
      feature4Title: 'Comunidad Acogedora',
      feature4Text: 'Somos una familia que se cuida y apoya mutuamente',
      feature5Title: 'Proyectos Solidarios',
      feature5Text: 'Desarrollo de responsabilidad social y compromiso comunitario',
      feature6Title: 'Preparación para el Futuro',
      feature6Text: 'Herramientas tecnológicas y habilidades para el siglo XXI',
      statsTitle: 'Nuestros Números',
      years: 'Años de experiencia',
      students: 'Estudiantes',
      teachers: 'Docentes',
      vision: 'Visión: Ser líderes en educación',
      documentsTitle: 'Documentos importantes',
      documentsNote: 'Consulta y descarga los documentos oficiales del centro educativo.',
      documentsNormative: 'Normativa de Evaluación CEAM 2026',
      ctaTitle: '¿Quieres ser parte de nuestra comunidad?',
      ctaText: 'Contáctanos para conocer más sobre cómo podemos ayudar en la educación integral de tus hijos.',
      ctaNow: 'Contactar ahora'
    },
    location: {
      title: 'Contáctanos',
      lead: 'Visítanos o contacta directamente. Estamos aquí para ayudarte.',
      locationTitle: 'Nuestra ubicación',
      formTitle: 'Formulario de consulta',
      success: '✓ Mensaje enviado correctamente',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      subject: 'Asunto',
      message: 'Mensaje',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'tu@email.com',
      phonePlaceholder: '+506 ____-____',
      subjectPlaceholder: '¿Sobre qué es tu consulta?',
      messagePlaceholder: 'Cuéntanos tu consulta...',
      send: 'Enviar consulta',
      infoTitle: 'Información de contacto'
    }
  },
  en: {
    nav: {
      home: 'Home',
      admissions: 'Admissions',
      about: 'About',
      contact: 'Contact Us',
      volunteer: 'Volunteer'
    },
    common: {
      brand: 'CEAM',
      schoolName: 'Centro Educativo Adventista de Monteverde',
      schedule: 'Schedule',
      weekHours: 'Monday to Thursday: 8:00 a.m. - 4:00 p.m. Friday: 8:00 a.m. - 12:45 p.m.',
      weekendHours: 'Saturdays and Sundays: Closed',
      enrollment2026: 'Enrollment 2026',
      enrollmentOpen: 'Open and available',
      familyInvite: 'Come and be part of our family!',
      website: 'Website',
      facebook: 'Facebook',
      whatsapp: 'WhatsApp',
      address: 'General Office',
      accounting: 'Accounting'
    },
    footer: {
      rights: '© 2026 Adventist Educational Center of Monteverde. All rights reserved.'
    },
    home: {
      eyebrow: 'Holistic education with values',
      heroTitle: 'Centro Educativo Adventista de Monteverde',
      heroLead: 'We form students with academic excellence, Christian principles, and commitment to the community.',
      visit: 'Schedule a visit',
      viewLevels: 'View levels',
      years: 'Years of experience',
      students: 'Students',
      teachers: 'Teachers',
      heroCardTitle: 'With Jesus by Our Side, an Unlimited Future',
      heroCardText: 'Discover a safe, modern, and welcoming environment for your children’s holistic growth.',
      heroCardList1: 'Preschool and Primary',
      heroCardList2: 'Music, science, and sports programs',
      heroCardList3: 'Personalized attention and spiritual support',
      requestInfo: 'Request information',
      pillarsTitle: 'Our pillars',
      pillar1Title: 'Academic excellence',
      pillar1Text: 'Updated programs and teachers committed to learning.',
      pillar2Title: 'Christian values',
      pillar2Text: 'Spiritual formation based on love, service, and respect.',
      pillar3Title: 'Active community',
      pillar3Text: 'Solidarity projects and activities that build character.',
      servicesTitle: 'Featured services',
      service1Title: 'Labs and technology',
      service1Text: 'Equipped spaces to foster creativity and research.',
      service2Title: 'Art and culture',
      service2Text: 'Choirs, bands, and art workshops for holistic development.',
      service3Title: 'Sports and wellness',
      service3Text: 'Promotion of healthy habits and teamwork.',
      volunteerTitle: 'Volunteer',
      volunteerText: 'Explore and apply to our volunteer opportunities.',
      volunteerButton: 'View opportunities'
    },
    volunteer: {
      title: 'Volunteer',
      lead: 'Learn about and apply to our volunteer opportunities.',
      monteverde: 'Volunteer in Monteverde',
      monteverdeDesc: 'Collaborate with our school in Monteverde and be part of the educational transformation.',
      santaElena: 'Volunteer in Santa Elena',
      santaElenaDesc: 'Join our volunteer program in Santa Elena and make a difference.',
      button1: 'View opportunities',
      button2: 'View opportunities'
    },
    admissions: {
      title: 'Educational levels',
      subtitle: 'Payable in 11 installments',
      preschool: 'Preschool',
      preschoolDesc: 'Play-based learning and holistic development in early ages.',
      primary: 'Primary',
      primaryDesc: 'Academic education with emphasis on values and skills.',
      infoTitle: 'Information',
      info1: 'Personalized education',
      info2: 'Safe and modern environments',
      info3: 'Skills development',
      info4: 'Playful activities',
      info5: 'Academic excellence',
      info6: 'Holistic education',
      info7: 'Values formation',
      info8: 'Personalized support',
      enrollmentFee: 'Enrollment',
      monthlyFee: 'Monthly fee',
      requestInfo: 'Request information',
      uniformsTitle: 'School uniforms',
      polo: 'Daily polo shirt',
      pe: 'Physical education shirt',
      books: 'Books',
      booksNote: 'Ask at the school or via',
      programsTitle: 'Special programs',
      program1Title: 'English with native volunteers',
      program1Text: 'English immersion with specialized teachers.',
      program2Title: 'Computing and robotics lab',
      program2Text: 'Preparation for tomorrow’s technological challenges.',
      program3Title: 'Blended learning',
      program3Text: 'Playful experiences and innovative experimental projects.'
    },
    contact: {
      title: 'Contact Us',
      lead: 'Have questions? We would love to hear from you. Fill out the form and we will get in touch.',
      success: '✓ Message sent successfully',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+506 ____-____',
      messagePlaceholder: 'Tell us about your inquiry...',
      send: 'Send message',
      infoTitle: 'Contact information',
      hours: 'Hours:',
      enrollmentOpen: 'Enrollment 2026 open',
      enrollmentInvite: 'Be part of our family!',
      address: 'Office',
      web: 'Web'
    },
    about: {
      title: 'About us',
      lead: 'Learn about the history, mission, and values of the Centro Educativo Adventista de Monteverde',
      historyTitle: 'Our History',
      historyP1: 'The Adventist Educational Center of Monteverde (CEAM) was born with the vision of offering holistic education that combines academic excellence with Christian values. With more than 25 years of experience, we have impacted the lives of hundreds of students and their families.',
      historyP2: 'Since our beginnings, we have maintained the commitment to be more than a school: we are a family dedicated to the holistic education of our students under biblical principles.',
      missionTitle: 'Our Mission',
      missionP1: 'Provide quality holistic education that develops academic excellence, strong Christian values, and commitment to the community. We seek to form responsible and ethical citizens who contribute positively to society.',
      valuesTitle: 'Our Values',
      value1: 'Excellence',
      value1Text: 'We strive for the highest quality in everything we do',
      value2: 'Integrity',
      value2Text: 'We act with honesty and transparency in all our actions',
      value3: 'Love',
      value3Text: 'We show Christian love in our relationships',
      value4: 'Responsibility',
      value4Text: 'We take commitments and fulfill our obligations',
      value5: 'Respect',
      value5Text: 'We value and respect the dignity of each person',
      chooseTitle: 'Why choose CEAM?',
      feature1Title: 'Holistic Education',
      feature1Text: 'We develop all areas of the person: academic, emotional, physical, and spiritual',
      feature2Title: 'Academic Excellence',
      feature2Text: 'Qualified teachers, modern methodologies, and updated programs',
      feature3Title: 'Christian Values',
      feature3Text: 'Formation based on biblical principles that transform lives',
      feature4Title: 'Welcoming Community',
      feature4Text: 'We are a family that cares and supports each other',
      feature5Title: 'Solidarity Projects',
      feature5Text: 'Development of social responsibility and community commitment',
      feature6Title: 'Future Readiness',
      feature6Text: 'Technological tools and 21st-century skills',
      statsTitle: 'Our Numbers',
      years: 'Years of experience',
      students: 'Students',
      teachers: 'Teachers',
      vision: 'Vision: To be leaders in education',
      documentsTitle: 'Important documents',
      documentsNote: 'Review and download official documents from the school.',
      documentsNormative: 'CEAM Evaluation Guidelines 2026',
      ctaTitle: 'Want to be part of our community?',
      ctaText: 'Contact us to learn more about how we can support your children’s holistic education.',
      ctaNow: 'Contact now'
    },
    location: {
      title: 'Contact Us',
      lead: 'Visit us or contact us directly. We are here to help.',
      locationTitle: 'Our location',
      formTitle: 'Inquiry form',
      success: '✓ Message sent successfully',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      subject: 'Subject',
      message: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'your@email.com',
      phonePlaceholder: '+506 ____-____',
      subjectPlaceholder: 'What is your inquiry about?',
      messagePlaceholder: 'Tell us about your inquiry...',
      send: 'Send inquiry',
      infoTitle: 'Contact information'
    }
  }
};

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''), obj);
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = localStorage.getItem('ceam-lang');
    return stored || 'es';
  });

  const toggleLanguage = useCallback(() => {
    setLang((prev) => {
      const next = prev === 'es' ? 'en' : 'es';
      localStorage.setItem('ceam-lang', next);
      return next;
    });
  }, []);

  const t = useCallback(
    (path) => getNestedValue(translations[lang], path),
    [lang]
  );

  const value = useMemo(() => ({ lang, t, toggleLanguage }), [lang, t, toggleLanguage]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}
